export default __webpack_public_path__ + "static/media/ag_14.47fc7743.wav";